export default __webpack_public_path__ + "assets/Orion_with_satellites.6ed91b09.jpg";